import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IEucFile } from '../dto/EucUpload';

@Module({ dynamic: true, store, name: 'eucUpload', namespaced: true })
class EucUpload extends VuexModule implements IEucFile {

    // state
    /**
     * @state
     * ファイルデータDB
     * ファイル情報を格納する
     */
    uploadFileDb: any = [];

    /**
     * @state
     * ファイルデータSQL
     * ファイル情報を格納する
     */
    uploadFileSql: any = [];

    /**
     * @state
     * ファイルデータINF
     * ファイル情報を格納する
     */
    uploadFileInf: any = [];

    /**
     * @state
     * ファイルデータEXCEL
     * ファイル情報を格納する
     */
    uploadFileExcel: any = [];

    // getter
    /**
     * @Getter
     * uploadFileDbの取得
     */
    get GET_UPLOAD_FILE_DB() {
        return this.uploadFileDb;
    }

    /**
     * @Getter
     * uploadFileSQLの取得
     */
    get GET_UPLOAD_FILE_SQL() {
        return this.uploadFileSql;
    }

    /**
     * @Getter
     * uploadFileINFの取得
     */
    get GET_UPLOAD_FILE_INF() {
        return this.uploadFileInf;
    }

    /**
     * @Getter
     * uploadFileEXCELの取得
     */
    get GET_UPLOAD_FILE_EXCEL() {
        return this.uploadFileExcel;
    }

    // action
    /**
     * @Action
     * アップロードファイルデータDBの保管
     * @param data
     */
    @Action({})
    public setUploadFileDb(data: any) {
        this.SET_UPLOAD_FILE_DB(data);
    }

    /**
     * @Action
     * アップロードファイルデータSQLの保管
     * @param data
     */
    @Action({})
    public setUploadFileSql(data: any) {
        this.SET_UPLOAD_FILE_SQL(data);
    }

    /**
     * @Action
     * アップロードファイルデータINFの保管
     * @param data
     */
    @Action({})
    public setUploadFileInf(data: any) {
        this.SET_UPLOAD_FILE_INF(data);
    }

    /**
     * @Action
     * アップロードファイルデータEXCELの保管
     * @param data
     */
    @Action({})
    public setUploadFileExcel(data: any) {
        this.SET_UPLOAD_FILE_EXCEL(data);
    }

    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    // mutation
    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE_DB(data: any) {
        this.uploadFileDb = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE_SQL(data: any) {
        this.uploadFileSql = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE_INF(data: any) {
        this.uploadFileInf = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE_EXCEL(data: any) {
        this.uploadFileExcel = data;
    }

    @Mutation
    private MODULE_RESET() {
        this.uploadFileDb = '';
        this.uploadFileSql = '';
        this.uploadFileInf = '';
        this.uploadFileExcel = '';
    }
}

export const eucUploadModule = getModule(EucUpload);
